import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tuberia',
  templateUrl: './tuberia.component.html',
  styleUrls: ['./tuberia.component.css']
})
export class TuberiaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
